<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <v-card class="pa-4 pt-0">
        <v-row justify="start">
        <v-breadcrumbs :items="crump" divider=">" color="#808080"></v-breadcrumbs>
      </v-row>
      <v-row class="pt-0">
        <v-col cols="6" xs="12" class="pt-0">
          <v-card-text>
            <span class="headline font-weight-light">Standort<span v-if="companyData">"{{companyData.name}}"</span> </span>
          </v-card-text>
        </v-col>
        <v-col cols="6" xs="12" style="text-align: right">
          <v-btn @click="close" icon color="red"><v-icon>close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-tabs
      v-model="tab"
      background-color="#EEEEEE"
      color="black"
      @change="onChangeTab"
      grow
      v-if="showTabs"
      >
        <v-tab href="#tabStammdaten">Stammdaten</v-tab>
        <v-tab href="#tabComments">Kommentare</v-tab>
        <v-tab href="#tabBenutzer">Benutzer</v-tab>
        <v-tab>Playlist</v-tab>
        <v-tab>Geräte</v-tab>
        <v-tab>Standorte</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tabStammdaten">
          <TabDefault ref="tabs0" :tagList="tagList" :company-id="locationId" :form-data="companyData"></TabDefault>
        </v-tab-item>
        <v-tab-item value="tabComments">
          <TableComments ref="tabs1" :tagList="tagList" :company-id="locationId" :form-data="companyData"></TableComments>
        </v-tab-item>
        <v-tab-item value="tabBenutzer">
          <TabUser ref="tabs2" :company-id="locationId" :companyOwnerID="companyId" :form-data="companyData"></TabUser>
        </v-tab-item>
        <v-tab-item>
          <TabPlaylist ref="tabs3" :company-id="locationId" :form-data="companyData"></TabPlaylist>
        </v-tab-item>
        <v-tab-item>
          <TabDevices ref="tabs4" :company-id="locationId" :form-data="companyData"></TabDevices>
        </v-tab-item>
        <v-tab-item>
          <TabStandorte ref="tabs5" :company-id="locationId" :form-data="companyData"></TabStandorte>
        </v-tab-item>
      </v-tabs-items>

    </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TabDefault from './TabDefault'
import TabDevices from "./TabDevices"
import TabPlaylist from "./TabPlaylist"
import TabStandorte from "./TabStandorte"
import TabUser from "./TabUser"
import TableComments from "@/components/tables/TableComments";

export default {
  name: 'Firmen',
  components: {TableComments, TabDevices, TabDefault, TabPlaylist, TabStandorte, TabUser},
  data () {
    return {
      crump: [{
        text: 'Dashboard',
        disabled: false,
        href: '/#/Dashboard/Netzwerke',
      }],
      tab: null,
      companyId: '-1',
      locationId: '-1',
      tagList: [],
      showTabs: false,
      companyData: {
        name: '',
        costCenter: '',
        street: '',
        zip: '',
        city: '',
        email: '',
        phone: '',
        create: '',
        changed: ''
      }
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('company', data)
      if (data.tags === null) {
        data.tags = '[]'
      }
      data.tags = JSON.parse(data.tags)
      this.companyData = data
      this.showTabs = true
    },
    onChangeTab: function() {
      if (this.$refs['tabs'+this.tab] && this.$refs['tabs'+this.tab].reload) {
        this.$refs['tabs'+this.tab].reload()
      }
    },
    close: function () {
      window.history.back();
    }
  },
  mounted () {
    this.companyId = this.$route.params.companyId
    if (this.$route.params.locationId) {
      this.locationId = this.$route.params.locationId
      Vue.prototype.$apiCompany.loadCompany(this.locationId, this.onGetData)
    } else {
      Vue.prototype.$apiCompany.loadCompany(this.companyId, this.onGetData)
      this.locationId = null
    }
    if (this.$route.params.companyId) {
      this.crump.push({
          text: 'Unternehmen',
          href: '/#/Netzwerke/' + this.$route.params.companyId
        })
    }

  }
}
</script>

<style scoped>

</style>
